import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveDynamicComponent as _resolveDynamicComponent, mergeProps as _mergeProps, createBlock as _createBlock, createTextVNode as _createTextVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f748fcaa"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "badge bg-green ms-3 fs-6"
}
const _hoisted_2 = { class: "mb-4" }
const _hoisted_3 = {
  class: "btn-group",
  role: "group",
  "aria-label": "Own product tabs"
}
const _hoisted_4 = ["data-bs-toggle", "title"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseTitle = _resolveComponent("BaseTitle")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_GenericFormWrapper = _resolveComponent("GenericFormWrapper")!
  const _component_base_container = _resolveComponent("base-container")!
  const _component_ProductDetailPhotosTab = _resolveComponent("ProductDetailPhotosTab")!
  const _component_base_offcanvas = _resolveComponent("base-offcanvas")!
  const _component_CatalogBuildStatus = _resolveComponent("CatalogBuildStatus")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_base_container, { "has-build-status-on-page": "" }, {
      default: _withCtx(() => [
        _createVNode(_component_BaseTitle, {
          title: _ctx.$t('ownProduct'),
          mode: _ctx.mode,
          "help-text": _ctx.$t('descriptionOwnProductsDetail'),
          "back-route": {name: 'customer-products'},
          "show-refresh-button": "",
          onRefresh: _ctx.reloadContent
        }, {
          icons: _withCtx(() => [
            (_ctx.product.product.name)
              ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(_ctx.product.product.name), 1))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["title", "mode", "help-text", "onRefresh"]),
        _createVNode(_component_GenericFormWrapper, {
          submitData: _ctx.submitData,
          pageUI: _ctx.pageUI,
          buttonClass: "btn-sm"
        }, {
          content: _withCtx(({errors}) => [
            _createElementVNode("nav", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("button", {
                  type: "button",
                  class: _normalizeClass(["btn btn-outline-primary", {'active':_ctx.currentComponent === 'product'}]),
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setCurrentComponent('product')))
                }, _toDisplayString(_ctx.$t('product')), 3),
                _createElementVNode("button", {
                  type: "button",
                  class: _normalizeClass(["btn btn-outline-primary", {'active':_ctx.currentComponent === 'properties'}]),
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setCurrentComponent('properties')))
                }, _toDisplayString(_ctx.$t('properties')), 3),
                _createElementVNode("button", {
                  type: "button",
                  class: _normalizeClass(["btn btn-outline-primary", {'disabled': _ctx.mode === _ctx.PageDetailModeEnum.NEW, 'disabled-with-tooltip': _ctx.mode === _ctx.PageDetailModeEnum.NEW}]),
                  "data-bs-toggle": _ctx.mode === _ctx.PageDetailModeEnum.NEW ? 'tooltip' : '',
                  title: _ctx.mode === _ctx.PageDetailModeEnum.NEW ? _ctx.$t('saveProductFirstToAddPhotos') : '',
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.mode === _ctx.PageDetailModeEnum.EDIT && _ctx.openPhotosOffCanvas('properties')))
                }, _toDisplayString(_ctx.$t('photos')), 11, _hoisted_4)
              ])
            ]),
            (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.currentComponent), _mergeProps({
              modelValue: _ctx.product,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.product) = $event)),
              errors: errors
            }, _ctx.currentProperties, { "onUpdate:modelValue": _ctx.onFormDataChanged }), null, 16, ["modelValue", "errors", "onUpdate:modelValue"]))
          ]),
          buttons: _withCtx(() => [
            _createVNode(_component_router_link, {
              to: {name: 'customer-products'},
              class: "ms-3 btn btn-outline-primary btn-sm"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('cancel')), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["submitData", "pageUI"])
      ]),
      _: 1
    }),
    (_ctx.mode === _ctx.PageDetailModeEnum.EDIT)
      ? (_openBlock(), _createBlock(_component_base_offcanvas, {
          key: 0,
          title: _ctx.$t('photos'),
          id: "offcanvas-customer-product-photos",
          class: "offcanvas-wider"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_ProductDetailPhotosTab, {
              "product-code": _ctx.productCode,
              addCloseOffCanvasButton: true,
              onSavedSuccessfully: _ctx.reloadImage
            }, null, 8, ["product-code", "onSavedSuccessfully"])
          ]),
          _: 1
        }, 8, ["title"]))
      : _createCommentVNode("", true),
    _createVNode(_component_CatalogBuildStatus)
  ], 64))
}